<template>
<div class="layout-control-btn">
    <!-- <div class="info-layout">Hello World</div> -->
    <div class="action-layout">
        <!-- NOTE Button Mode Display -->
        <!-- <u-action-btn v-if="!disableDisplayBtn" class="gap-control-btn" v-model="control.display" icon="mdi-grid" iconActive="mdi-square-rounded-badge" colorActive="gray" tooltip="โหมดการแสดงผล" tooltipActive="โหมดการแสดงผล" fab @click="$emit('clickDisplayBtn', control)">
        </u-action-btn> -->

        <!-- NOTE Button Recoding -->
        <u-action-btn v-if="!disableRecordBtn" class="gap-control-btn" v-model="control.record" icon="mdi-radiobox-marked" iconActive="mdi-radiobox-marked" color="error" colorActive="gray" tooltip="หยุดการบันทึก" tooltipActive="เริ่มการบันทึก" fab @click="$emit('clickRecordBtn', control)">
        </u-action-btn>

        <!-- NOTE Button Camera -->
        <u-action-btn v-if="!disableCameraBtn" class="gap-control-btn" v-model="control.camera" icon="mdi-video" iconActive="mdi-video-off" tooltip="ปิดกล้อง" tooltipActive="เปิดกล้อง" fab @click="$emit('clickCameraBtn', control)">
        </u-action-btn>

        <!-- NOTE Button Mic -->
        <u-action-btn v-if="!disableMicrophoneBtn" class="gap-control-btn" v-model="control.microphone" icon="mdi-microphone" iconActive="mdi-microphone-off" tooltip="ปิดไมโครโฟน" tooltipActive="เปิดไมโครโฟน" fab @click="$emit('clickMicrophoneBtn', control)">
        </u-action-btn>

        <!-- NOTE Screen Shared Button -->
        <!-- <u-action-btn v-if="!disableSharedScreenBtn" class="gap-control-btn" reverse v-model="control.screen" icon="mdi-monitor-off" iconActive="mdi-monitor-share" tooltip="แชร์หน้าจอ" tooltipActive="หยุดแชร์หน้าจอ" fab @click="$emit('clickSharedScreenBtn', control)">
        </u-action-btn> -->
        <!-- NOTE Layout Optionals -->
        <div class="gap-control-btn">
            <slot name="options"></slot>
        </div>

        <v-divider class="mx-1" inset vertical></v-divider>

        <!-- NOTE Button Ending -->
        <u-action-btn v-if="!disableEndingBtn" class="mx-1" icon="mdi-phone-hangup" iconActive="mdi-phone-hangup" tooltip="สิ้นสุดการสนทนา" tooltipActive="สิ้นสุดการสนทนา" rounded width="50" @click="$emit('clickEndingBtn', control)">
        </u-action-btn>
    </div>

    <!-- NOTE Layout Chat 2023-04-17 -->
    <div v-if="!disableChatBtn" class="chat-layout">
        <slot name="chat"> </slot>
    </div>

    <!-- NOTE Layout Optionals -->
    <!-- <div class="option-layout">
        <slot name="options"></slot>
    </div> -->

    <!-- NOTE Dialog Shared link -->
    <!-- <v-menu
      top
      :offset-y="true"
      v-model="offset"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Dropdown
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu> -->
</div>
</template>

<script>
// NOTE Component Spect---------------------------------------
// TODO Props
// [x] value => ใช้ในการรรับของผ่าน v-model

// TODO  Event
// [x] clickDisplayBtn => เมื่อมีการ click Display Btn
// [x] clickRecordBtn => เมื่อมีการ click Record Btn
// [x] clickCameraBtn => เมื่อมีการ click Camera Btn
// [x] clickMicrophoneBtn => เมื่อมีการ click Microphone Btn
// [x] clickSharedScreenBtn => เมื่อมีการ click Shared Screen Btn
// [x] clickEndingBtn => เมื่อมีการ click Ending btn
// NOTE Component Spect---------------------------------------

export default {
  data () {
    return {
      s: false
    }
  },
  props: {
    value: {
      type: Object,
      validator (val) {
        // NOTE ใช้ในการ Validate Props Conterol ที่ใช้ใน Control
        const keys = ['camera', 'microphone', 'record', 'screen', 'display']
        if (keys.every((x) => Object.keys(val).includes(x))) return true
        else {
          console.warn(val)
          return false
        }
      },
      default: () => {
        return {
          camera: false,
          microphone: false,
          record: false,
          screen: false,
          display: false
        }
      }
    },
    channel: {
      type: String,
      default: ''
    },

    // NOTE Disable Action Button --------------
    // TODO Hidden Switch moode button
    disableDisplayBtn: {
      type: Boolean,
      default: false
    },

    // TODO Hidden Record button
    disableRecordBtn: {
      type: Boolean,
      default: false
    },

    // TODO Hidden Camera button
    disableCameraBtn: {
      type: Boolean,
      default: false
    },

    // TODO Hidden Microphone button
    disableMicrophoneBtn: {
      type: Boolean,
      default: false
    },

    // TODO Hidden Shared Screen Button
    disableSharedScreenBtn: {
      type: Boolean,
      default: false
    },

    // TODO Hiddent Ending Button
    disableEndingBtn: {
      type: Boolean,
      default: false
    },
    disableChatBtn: {
      type: Boolean,
      default: false
    }
    // NOTE Disable Action Button --------------
  },
  computed: {
    control: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', {
          ...{
            camera: false,
            microphone: false,
            record: false,
            screen: false,
            display: false
          },
          ...val
        })
        // this.$emit('input', val)
      }
    },
    link () {
      return `${window.location.origin}/${this.channel}`
    }
  },
  methods: {
    copyText () {
      const textToCopy = this.$refs.textToCopy.$el.querySelector('input')
      textToCopy.select()
      document.execCommand('copy')
    },
    BtnSharedScreen () {
      this.control.screen = !this.control.screen
      this.$emit('sharedscreen', this.control.screen)
    }
  }
}
</script>

<style lang="css" scoped>
.gap-control-btn{
  /* margin-right: 4px;
  margin-left: 4px;
   */
   padding-right: 4px;
   padding-left: 4px;

   /* background: red; */
}
.layout-control-btn {
    overflow: hidden !important;
    /* height: 50px; */
    /* height: 100%; */
    display: flex;
    justify-content: center;
    /* justify-content: space-between; */
  /* background-color: rgba(32, 64, 156, 0.15); */
    /* opacity: 0.2; */

    /* align-items: center; */
    /* background: var(--v-primary-base); */
}

.layout-control-btn .info-layout {
    /* background: red; */
    height: 100%;
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding-left: 1em;
  padding-right: 1em; */
}

.layout-control-btn .action-layout {
    /* background: pink; */
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background: red; */
    background-color: rgba(32, 64, 156, 0.15);
    border-radius: 12px;
    width: fit-content;
    padding: 8px;

    /* padding-left: 1em;
  padding-right: 1em; */
}

.layout-control-btn .option-layout,
.layout-control-btn .chat-layout {
    /* background: blueviolet; */
    height: 100%;
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding-left: 1em;
  padding-right: 1em; */
}

>>>.btn-control {
    font-size: 10px !important;
}
</style>
